<template>
  <el-table ref="singleTable" :data="allData" :max-height="tableHeight1" stripe style="width: 100%">
    <el-table-column type="index" width="50" label="  ">
      <template slot-scope="scope">
        <span>{{scope.$index+index+1}}</span>
      </template>
    </el-table-column>
    <el-table-column width="120" property="roadName" label="道路" align="center"></el-table-column>
    <el-table-column label="全部车辆" align="center">
      <el-table-column
          property="allCarStopTotal"
          label="停靠合计"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="allCarStopSinopec"
          label="S级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="allCarStopPetrochina"
          label="C级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="allCarStopOther"
          label="E级油站"
          width="80" align="center">
        </el-table-column>
    </el-table-column>
    <el-table-column label="柴油车辆" align="center">
      <el-table-column
          property="dieselCarStopTotal"
          label="停靠合计"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="dieselCarStopSinopec"
          label="S级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="dieselCarStopPetrochina"
          label="C级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="dieselCarStopOther"
          label="E级油站"
          width="80" align="center">
        </el-table-column>
    </el-table-column>
    <el-table-column label="LNG车辆" align="center">
      <el-table-column
          property="lngCarStopTotal"
          label="停靠合计"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="lngCarStopSinopec"
          label="S级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="lngCarStopPetrochina"
          label="C级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="lngCarStopOther"
          label="E级油站"
          width="80" align="center">
        </el-table-column>
    </el-table-column>
    <el-table-column label="新能源车辆" align="center">
      <el-table-column
          property="nerCarStopTotal"
          label="停靠合计"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="nerCarStopSinopec"
          label="S级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="nerCarStopPetrochina"
          label="C级油站"
          width="80" align="center">
        </el-table-column>
        <el-table-column
          property="nerCarStopOther"
          label="E级油站"
          width="80" align="center">
        </el-table-column>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    allData: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      tableHeight1:this.tableHeight+120,
    }
  },
  methods: {
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
  },
}
</script>